import gql from "graphql-tag";

export const GET_URL_FOR_IMAGE = gql`
  query getUploadUrl($contentType: String!, $extension: String!) {
    getUploadUrl(contentType: $contentType, extension: $extension)
  }
`;
